export enum MetaKey {
	MEETING_TYPE = 'meetingType',
	SUKL_LOGIN = 'suklLogin',
	SUKL_PASSWORD = 'suklPassword',
	SUKL_LOGIN_TEMPORARY = 'suklLoginTemporary',
	PROVIDER_CODE = 'providerCode',
	HEALTH_CARE_WORKER_CODE = 'healthCareWorkerCode',
	PESEL = 'pesel',
	BIRTH_PLACE = 'birthPlace',
	MOTHERS_FULLNAME = 'mothersFullname',
	TAJ = 'taj',
	EMSO = 'emso',
	JMBG = 'jmbg',
	WORKLOAD = 'workload',
	IDENTIFICATION_NUMBER = 'identificationNumber',
	CAN_CREATE_CASE_ON_PERMANENT_MEDICATION = 'canCreateCaseOnPermanentMedication',
	LAST_IDENTIFICATION_CODE = 'lastIdentificationCode',
}
